import { Box, Link, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';

import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isEmpty, useFirestoreConnect } from 'react-redux-firebase';
import { useSelector } from 'react-redux';

const RoleSelect = ({ children }) => {
  const auth = useSelector((state) => state.firebase.auth);

  const rolesArray = useMemo(() => {
    if (auth.uid) {
      return [
        {
          collection: 'roles',
          where: [
            ['uid', '==', auth.uid],
            ['deleted', '==', 0],
          ],

          storeAs: 'userRoles',
        },
      ];
    } else {
      return [];
    }
  }, [auth.uid]);

  useFirestoreConnect(rolesArray);

  const userRoles = useSelector((state) => state.firestore.ordered.userRoles);

  if (isEmpty(userRoles)) {
    return null;
  }

  return (
    <>
      {children}
      <Box
        mt={2}
        display="flex"
        flexDirection="column"
        align="center"
        justifyContent="center"
      >
        <Typography
          color="secondary"
          align="center"
          paragraph
          fontWeight={400}
          fontSize={20}
        >
          Please select a portal
        </Typography>
        {userRoles?.map((role) => (
          <Link
            key={role.clientId}
            component={NavLink}
            to={`/${role.clientId}`}
            variant="body2"
            color="primary"
            underline="hover"
            sx={{ mb: 1 }}
          >
            {role.clientName}
          </Link>
        ))}
      </Box>
    </>
  );
};

RoleSelect.defaultProps = {
  children: null,
};

RoleSelect.propTypes = {
  children: PropTypes.node,
};

export default RoleSelect;
